import api from "./api";

export async function getWorkorderActivities(workorderId) {
  const res = await api.get(`/workorders/${workorderId}/activities`);
  return Array.isArray(res.data) ? res.data : [];
}

export async function createActivity(payload) {
  const res = await api.post("/activities", payload);
  return res.data;
}

export async function updateActivity(activityId, payload) {
  const res = await api.patch(`/activities/${activityId}`, payload);
  return res.data;
}

export async function deleteActivity(activityId) {
  const res = await api.delete(`/activities/${activityId}`);
  return res.data;
}

export async function startTime(payload) {
  const res = await api.post("/time/start", payload);
  return res.data;
}

export async function stopTime(payload) {
  const res = await api.post("/time/stop", payload);
  return res.data;
}

export async function getWorkorderTimeEntries(workorderId) {
  const res = await api.get(`/workorders/${workorderId}/time-entries`);
  return Array.isArray(res.data) ? res.data : [];
}

export async function getStopReasons() {
  const res = await api.get("/stop-reasons");
  return Array.isArray(res.data) ? res.data : [];
}

export async function uploadPhoto(formData) {
  const res = await api.post("/photos/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function getWorkorderPhotos(workorderId) {
  const res = await api.get(`/workorders/${workorderId}/photos`);
  return Array.isArray(res.data) ? res.data : [];
}

export async function getWorkorderDaylog(workorderId) {
  const res = await api.get(`/workorders/${workorderId}/daylog`);
  return Array.isArray(res.data) ? res.data : [];
}
